export default class MediaLibraryArchiveStorage
{
    constructor()
    {
        /** @type {string} */
        this._prefix = 'ml-download-';
    }

    /**
	 * Save the download information to local storage
	 * @param {string} customerId - The customer ID
	 * @param {string} jsonPath - The path to the JSON file
	 * @param {Array} fileFormats - The selected file format
	 * @param {object[]} assets - The selected assets
	 */
    setStorage(customerId, jsonPath, fileFormats, assets)
    {
        if (!customerId || !jsonPath || !fileFormats || !Array.isArray(assets) || !assets.length)
        {
            console.error('customerId is required or download information are incomplete');
            return;
        }

        let data = {
            jsonPath: jsonPath,
            fileFormats: fileFormats,
            assets: assets
        };

        localStorage.setItem(this._prefix + customerId, JSON.stringify(data));
    }

    /**
	 * Restore the download information from local storage
	 * @param {string} customerId - The customer ID
	 */
    getStorage(customerId)
    {
        if (!customerId)
        {
            console.error('customerId is required');
            return;
        }

        return JSON.parse(localStorage.getItem(this._prefix + customerId));
    }

    /**
	 * Clear the download information from local storage
	 * @param {string} customerId - The customer ID
	 */
    removeStorage(customerId)
    {
        if (!customerId)
        {
            console.error('customerId is required');
            return;
        }

        localStorage.removeItem(this._prefix + customerId);
    }

    /**
	 * Check if download information exists in local storage
	 * @param {string} customerId - The customer ID
	 * @return {boolean} Whether download information exist in local storage
	 */
    checkStorage(customerId)
    {
        if (!customerId)
        {
            console.error('customerId is required');
            return false;
        }

        return !!localStorage.getItem(this._prefix + customerId);
    }
}
